import CreditNoteAllocationForm from '../Layout/Xero/CreditNoteAllocationForm';
import EmailInvoiceForm from '../Layout/Xero/EmailInvoiceForm';
import { api } from "../Http";
import CustomizeRecordToFind from "../Layout/Salesforce/CustomizeRecordToFind";
import FindData from "../Layout/Salesforce/FindData";
import ChooseAccount from "../Layout/stepUtils/ChooseAccount";
import BankTransactionForm from "../Layout/Salesforce/TransactionForm";
import ContactForm from "../Layout/Xero/ContactForm";
import OnlineInvoiceUrlForm from "../Layout/Xero/OnlineInvoiceUrlForm";
import CreditNoteForm from "../Layout/Xero/CreditNoteForm";
import FindItemData from "../Layout/Xero/FindItemData";
import InvoiceForm from "../Layout/Xero/InvoiceForm";
import InvoicePdfForm from "../Layout/Xero/InvoicePdfForm";
import ItemForm from "../Layout/Xero/ItemForm";
import PurchaseOrderForm from "../Layout/Xero/PurchaseOrderForm";
import QuoteForm from "../Layout/Xero/QuoteForm";
import SendData from "../Layout/Xero/SendData";

const XERO_COMMON = [
  {
    title: "Choose Account",
    content: () => (
      <ChooseAccount
        authRequestFunction={(cb) => {
          api
            .get("/api/xero")
            .then((resp) => {
              if (resp.data.code === 0) {
                const popWindow = window.open(
                  resp.data.data,
                  "newwindow",
                  "width=800,height=600",
                );
                const syncWindow = setInterval(() => {
                  //console.log('open');
                  if (popWindow.closed) {
                    cb();
                    //console.log('closed');
                    clearInterval(syncWindow);
                  }
                }, 500);
              }
            })
            .catch((e) => console.log(e));
        }}
      />
    ),
  },
];

const XERO_CREATE_SALES_INVOICE = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Customize Record",
      content: () => <InvoiceForm />,
    },
    {
      title: "Send Data",
      content: () => <SendData delegateToUri="/api/xero/delegate" />,
    },
  ],
};

const XERO_NEW_BANKTRANSACTION = {
  steps: [...XERO_COMMON],
};

const XERO_CREATE_CREDIT_NOTE_ALLOCATION = {
  steps: [...XERO_COMMON, { title: 'Customize Allocation', content: () => <CreditNoteAllocationForm /> }],
};

const XERO_EMAIL_INVOICE = {
  steps: [...XERO_COMMON, { title: 'Customize Record', content: () => <EmailInvoiceForm /> }],
};

const XERO_GET_ONLINE_INVOICE_URL = {
  steps: [
    ...XERO_COMMON,
    { title: "Customize Record", content: () => <OnlineInvoiceUrlForm /> },
  ],
};

const XERO_CREATE_CREDIT_NOTE = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Customize Record",
      content: () => <CreditNoteForm />,
    },
    {
      title: "Send Data",
      content: () => <SendData delegateToUri="/api/xero/delegate" />,
    },
  ],
};

const XERO_CREATE_OR_UPDATE_CONTACT = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Customize Record",
      content: () => <ContactForm />,
    },
    {
      title: "Send Data",
      content: () => <SendData delegateToUri="/api/xero/delegate" />,
    },
  ],
};

const XERO_CREATE_OR_UPDATE_PURCHASE_ORDER = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Customize Record",
      content: () => <PurchaseOrderForm />,
    },
    {
      title: "Send Data",
      content: () => <SendData delegateToUri="/api/xero/delegate" />,
    },
  ],
};

const XERO_CREATE_OR_UPDATE_ITEMS = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Customize Record",
      content: () => <ItemForm />,
    },
    {
      title: "Send Data",
      content: () => <SendData delegateToUri="/api/xero/delegate" />,
    },
  ],
};

const XERO_GET_ITEMS = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Customize Record",
      content: () => <ItemForm />,
    },
    {
      title: "Send Data",
      content: () => <SendData delegateToUri="/api/xero/delegate" />,
    },
  ],
};

const XERO_TRIGGER_INVOICE_RECORD = {
  steps: [
    ...XERO_COMMON,

    {
      title: "Customize Record",
      content: () => <InvoiceForm showerror={false} />,
    },
    {
      title: "Send Data",
      content: () => <SendData delegateToUri="/api/xero/delegate" />,
    },
  ],
};

const XERO_NEW_MODIFY_ITEM = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Find Data",
      content: () => <FindItemData />,
    },
  ],
};

const XERO_NEW_MODIFY_INVOICE = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Customize Record",
      content: () => <CustomizeRecordToFind />,
    },
    {
      title: "Find Data",
      content: () => <FindData />,
    },
  ],
};

const XERO_CREATE_INVOICE_PDF = {
  steps: [
    ...XERO_COMMON,

    {
      title: "Customize Record",
      content: () => <InvoicePdfForm showerror={false} />,
    },
    {
      title: "Send Data",
      content: () => <SendData delegateToUri="/api/xero/delegate" />,
    },
  ],
};
const XERO_CREATE_QUOTE = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Customize Record",
      content: () => <QuoteForm />,
    },
    {
      title: "Send Data",
      content: () => <SendData delegateToUri="/api/xero/delegate" />,
    },
  ],
};

const XERO_UPDATE_QUOTE_RECORD = {
  steps: [...XERO_COMMON],
};

const NEW_XERO_CREDIT_NOTE = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Find Data",
      content: () => <FindItemData />,
    },
  ],
};

const XERO_UPDATE_INVOICE_RECORD = {
  steps: [...XERO_COMMON],
};

const XERO_NEW_PAYMENT_RECORD = {
  steps: [
    ...XERO_COMMON,
    {
      title: "Find Data",
      content: () => <FindItemData />,
    },
  ],
};

const XERO_NEW_CONTACT_RECORD = {
  steps: [...XERO_COMMON],
};
const XERO_NEW_ITEM_RECORD = {
  steps: [...XERO_COMMON],
};

export {
  XERO_CREATE_CREDIT_NOTE_ALLOCATION,
  XERO_EMAIL_INVOICE,
  XERO_GET_ONLINE_INVOICE_URL,
  XERO_CREATE_SALES_INVOICE,
  XERO_CREATE_CREDIT_NOTE,
  XERO_CREATE_OR_UPDATE_CONTACT,
  XERO_CREATE_OR_UPDATE_ITEMS,
  XERO_CREATE_OR_UPDATE_PURCHASE_ORDER,
  XERO_TRIGGER_INVOICE_RECORD,
  XERO_NEW_MODIFY_ITEM,
  XERO_NEW_MODIFY_INVOICE,
  XERO_CREATE_INVOICE_PDF,
  XERO_CREATE_QUOTE,
  XERO_UPDATE_QUOTE_RECORD,
  NEW_XERO_CREDIT_NOTE,
  XERO_UPDATE_INVOICE_RECORD,
  XERO_NEW_PAYMENT_RECORD,
  XERO_NEW_BANKTRANSACTION,
  XERO_NEW_CONTACT_RECORD,
  XERO_NEW_ITEM_RECORD,
  XERO_GET_ITEMS,
};
